// CSS entry file
require('./assets/styles/_entry.scss');

// JS to execute before DOMContentLoaded
require('./assets/js/_entry_onStartup.js');
